import React, { useState } from 'react';
import ChapaPayment from './ChapaPayment';
import '../../styles/ChapaPaymentForm.css';

const ChapaPaymentForm = ({ amount, onPaymentSuccess }) => {
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPayment, setShowPayment] = useState(false);

    const public_key = process.env.REACT_APP_CHAPA_PUBLIC_KEY;

    const validateField = (name, value) => {
        let errorMsg = '';

        if (name === 'fname') {
            if (!value) {
                errorMsg = 'First name is required';
            } else if (!/^[a-zA-Z]+$/.test(value)) {
                errorMsg = 'First name should contain only letters';
            } else if (value.length < 3) {
                errorMsg = 'First name should be at least 3 characters';
            }
        }

        if (name === 'lname') {
            if (!value) {
                errorMsg = 'Last name is required';
            } else if (!/^[a-zA-Z]+$/.test(value)) {
                errorMsg = 'Last name should contain only letters';
            } else if (value.length < 3) {
                errorMsg = 'Last name should be at least 3 characters';
            }
        }

        if (name === 'email') {
            if (!value) {
                errorMsg = 'Email is required';
            } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
                errorMsg = 'Email is not valid';
            }
        }

        return errorMsg;
    };

    const validate = () => {
        let tempErrors = {};

        tempErrors.fname = validateField('fname', fname);
        tempErrors.lname = validateField('lname', lname);
        tempErrors.email = validateField('email', email);
        if (amount <= 0) tempErrors.amount = 'Amount should be greater than 0';

        setErrors(tempErrors);
        return tempErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();

        if (Object.keys(validationErrors).filter(key => validationErrors[key]).length === 0) {
            setIsSubmitting(true);
            setShowPayment(true);
            // onPaymentSuccess();
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fname') setFname(value);
        if (name === 'lname') setLname(value);
        if (name === 'email') setEmail(value);

        const errorMsg = validateField(name, value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };

    const generateRandomHash = (length = 8) => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
        return result;
    };

    const generateTxRef = (fname, lname) => {
        const date = new Date();
        const formattedDate = date.toISOString().replace(/[-:T.]/g, '').slice(0, 14);
        const randomHash = generateRandomHash();
        return `${fname}_${lname}_${formattedDate}_${randomHash}`;
    };

    return (
        <div className="chapa_form_container">
            {!showPayment ? (
                <form className="chapa-payment-form" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="fname"
                        placeholder="First Name"
                        value={fname}
                        onChange={handleInputChange}
                    />
                    {errors.fname && <div className="error">{errors.fname}</div>}
                    <input
                        type="text"
                        name="lname"
                        placeholder="Last Name"
                        value={lname}
                        onChange={handleInputChange}
                    />
                    {errors.lname && <div className="error">{errors.lname}</div>}
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={email}
                        onChange={handleInputChange}
                    />
                    {errors.email && <div className="error">{errors.email}</div>}
                    <input
                        type="number"
                        name="amount"
                        placeholder="Amount"
                        value={amount}
                        readOnly
                        disabled
                    />
                    {errors.amount && <div className="error">{errors.amount}</div>}
                    <button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Processing...' : `Pay ${amount} Birr`}
                    </button>
                </form>
            ) : (
                <ChapaPayment
                    fname={fname}
                    lname={lname}
                    email={email}
                    amount={amount}
                    tx_ref={generateTxRef()}
                    public_key={public_key}
                />
            )}
        </div>
    );
};

export default ChapaPaymentForm;
